import { render, staticRenderFns } from "./CostSplitter.vue?vue&type=template&id=d3212356&scoped=true&"
import script from "./CostSplitter.vue?vue&type=script&lang=js&"
export * from "./CostSplitter.vue?vue&type=script&lang=js&"
import style0 from "./CostSplitter.vue?vue&type=style&index=0&id=d3212356&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3212356",
  null
  
)

export default component.exports